"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearIndicatorStyles = exports.ClearIndicator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var named_1 = require("../../../utils/named");
var MDIcon_1 = require("../../../components/MDIcon");
var ClearIndicator = function (tooltip) {
  return (0, named_1.named)("ClearIndicator", function (_a) {
    // TODO explore what this actually did
    // const gotStyles = getStyles('clearIndicator', { getStyles, innerProps })
    // console.log(gotStyles)
    var getStyles = _a.getStyles,
      innerProps = _a.innerProps;
    // TODO fix tooltip not actually showing up
    return (0, jsx_runtime_1.jsx)("div", __assign({}, innerProps, {
      ref: innerProps.ref,
      className: "insights-tooltip right",
      "data-tooltip": tooltip
    }, {
      children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
        align: "middle",
        icon: "close",
        size: 20
      })
    }));
  });
};
exports.ClearIndicator = ClearIndicator;
//@ts-ignore
var ClearIndicatorStyles = function (base, _) {
  return __assign({}, base);
};
exports.ClearIndicatorStyles = ClearIndicatorStyles;